import HomeView from 'views/Home'

const Home = () => {
  return <HomeView />
}

export default Home
